module.exports = __webpack_public_path__ + "img/A58A0366.52651f93.jpg";